import { useRouter } from 'next/router';
import { isPresent } from 'ts-is-present';

export function useSharingImage(id: string): string {
  const router = useRouter();

  const availableSharingImagesLocales = ['ar', 'en', 'es', 'fr'];

  const locale =
    isPresent(router.locale) && availableSharingImagesLocales.includes(router.locale)
      ? router.locale
      : 'en';

  return `/sharing/${locale}/${id}.png`;
}
